import React, { useState } from 'react';
import { capturesApi } from '../../api/captures';

export function ManualAddCapture({ scope, captureType, onCaptureCreated }) {
  const [isAdding, setIsAdding] = useState(false);
  const [content, setContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const entryType = captureType === 'ideas' ? 'idea' : 'todo';
  const noun = captureType === 'ideas' ? 'Idea' : 'To Do';

  const reset = () => {
    setContent('');
    setIsAdding(false);
  };

  const handleSubmit = async () => {
    const body = content.trim();
    if (!body || !scope?.id) return;

    setIsSubmitting(true);
    try {
      if (scope.type === 'story') {
        await capturesApi.createStory(scope.id, body, entryType);
      } else {
        await capturesApi.createProject(scope.id, body, entryType);
      }
      reset();
      onCaptureCreated?.();
    } catch (error) {
      console.error('Failed to create capture:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    } else if (e.key === 'Escape') {
      reset();
    }
  };

  if (!isAdding) {
    return (
      <button
        className="manual-add-capture__button"
        onClick={() => setIsAdding(true)}
      >
        + Add {noun}
      </button>
    );
  }

  return (
    <div className="manual-add-capture">
      <input
        type="text"
        className="manual-add-capture__input"
        placeholder={`Type ${captureType === 'ideas' ? 'an idea' : 'a To Do'} and press Enter…`}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isSubmitting}
        autoFocus
      />
      <div className="manual-add-capture__actions">
        <button
          className="manual-add-capture__cancel"
          onClick={reset}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          className="manual-add-capture__submit"
          onClick={handleSubmit}
          disabled={isSubmitting || !content.trim()}
        >
          Add
        </button>
      </div>
    </div>
  );
}

export default ManualAddCapture;
